module.exports = __webpack_public_path__ + "img/DAB_Sumitomo.13d42d6c.jpeg";